import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  connected: false,
  connecting: false,
  reconnectAttempts: 0,
  maxReconnectAttempts: 5,
  lastMessage: null,
  error: null,
  wsInstance: null
};

// Slice
const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setConnecting: (state, action) => {
      state.connecting = action.payload;
    },
    setConnected: (state, action) => {
      state.connected = action.payload;
      if (action.payload) {
        state.reconnectAttempts = 0;
        state.error = null;
      }
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.connected = false;
      state.connecting = false;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    },
    setLastMessage: (state, action) => {
      state.lastMessage = action.payload;
    },
    setWsInstance: (state, action) => {
      state.wsInstance = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

// Export actions
export const {
  setConnecting,
  setConnected,
  setError,
  incrementReconnectAttempts,
  resetReconnectAttempts,
  setLastMessage,
  setWsInstance,
  clearError
} = websocketSlice.actions;

// Selectors
export const selectWebSocketConnected = (state) => state.websocket.connected;
export const selectWebSocketConnecting = (state) => state.websocket.connecting;
export const selectWebSocketError = (state) => state.websocket.error;
export const selectReconnectAttempts = (state) => state.websocket.reconnectAttempts;
export const selectMaxReconnectAttempts = (state) => state.websocket.maxReconnectAttempts;
export const selectLastMessage = (state) => state.websocket.lastMessage;
export const selectWsInstance = (state) => state.websocket.wsInstance;

export default websocketSlice.reducer;